import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('assets')
export class BorrowerAsset extends Resource {
  borrowerId: number;
  assetId: number;
  type: AssetTypes;
  value: number;
  description: string;
  downPaymentAmount: number;
  financialInstitution: string;
}

export enum AssetTypes {
  // accounts
  mutualFunds = 'Mutual Fund/Stock/Bonds',
  chequing = 'Chequing Account',
  savings = 'Savings',
  rrsp = 'RRSP',

  //assets
  gift = 'Gift',
  householdGoods = 'Household Goods',
  vehicle = 'Vehicle',
  lifeInsurance = 'Life Insurance',

  //other
  other = 'Other',
  depositOnPurchase = 'Deposit on Purchase',
}

export const AccountTypes = [AssetTypes.chequing, AssetTypes.savings, AssetTypes.mutualFunds, AssetTypes.rrsp];
